$(() => {
    const tables = $('table');

    tables.each((i, e) => {
        let element = $(e);
        element.before(
            `<button class="btn btn-link a-modal-link a-modal-link--expand" data-toggle="modal" data-target="#table-modal-${i}">${lufLanguages.expandTable}</button>`);
        element.clone().appendTo('.a-main-content').attr("style", "width: " + element.width() + "px;").addClass('a-modal-table')
            .wrap(`<div class="modal" id="table-modal-${i}">
            <div class="modal-dialog modal-dialog-centered modal-lg"><div id="table-modal-content-${i}" class="modal-content a-table-modal">`);
        $(`#table-modal-content-${i}`)
            .prepend(
                `<div class="a-table-modal-close-container">
                <button class="btn btn-link a-modal-link a-modal-link--close" data-dismiss="modal" aria-label="${lufLanguages.closeTable}"><div class="a-modal-link--close--icon"><span></span><span></span></div></button>
            </div>`
            );
        $('.a-table-modal caption').addClass('a-table-modal-caption');
        element.attr({
            'id': `table-${i}`
        });
        const headers = element.find('thead tr td');
        if (headers.length > 0) {
            const rows = element.find('tbody tr');
            rows.each((idx, elementCell) => {
                $(elementCell).children().each((currentPosition, cell) => {
                    $(cell).attr('data-table-header', headers.get(currentPosition).innerText);
                });
            });
        }
    });
});